import { useEffect, useState } from "react";
import { TYPES } from "@/lib/script";
import { currentType, setLineType } from "@/components/script/ScriptMarks";

export const ScriptBar = ({ editor, mode }) => {
  const [, tick] = useState(0);
  useEffect(() => {
    if (!editor) return undefined;
    const on = () => tick((t) => t + 1);
    editor.on("transaction", on);
    return () => editor.off("transaction", on);
  }, [editor]);
  if (!editor) return null;
  const cur = currentType(editor.state);
  return (
    <div className="flex flex-wrap items-center gap-1 border-t border-[#2D3442] px-2 py-1" data-testid="script-bar">
      <span className="mr-1 text-[10px] uppercase tracking-[0.16em] text-[#A8A090]">{mode === "stage" ? "Stage play" : "Screenplay"} line</span>
      {TYPES[mode].map(([k, label, hint]) => (
        <button key={k} onMouseDown={(e) => e.preventDefault()} onClick={() => setLineType(editor, k)} title={`${hint} · Tab cycles line types`}
          className={`rounded px-2 py-0.5 text-xs transition-colors ${cur === k ? "bg-[#D97706] text-[#0B0D10]" : "text-[#D6CCBC] hover:bg-[#1A202C]"}`} data-testid={`script-type-${k}`}>{label}</button>
      ))}
    </div>
  );
};
